module.exports = __webpack_public_path__ + "static/media/calendar.b0d094f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/calendar.png
// module id = 805
// module chunks = 29